import { useEffect, useState } from 'react';
import { ItemSHSFRow } from './item-types';
import { ItemAPI } from '../../api/item';
import TableWrapperBase from '../shared/table';
import { dataTypes } from '../shared/table-helpers';
import { CircularProgress, Stack } from '@mui/material';

const TableWrapper = TableWrapperBase as any;

export interface ItemSHSFTableProps {
  month: number;
  year: number;
  itemId: string;
  locationId: number;
}
export default function ItemSHSFTable(props: ItemSHSFTableProps) {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [rows, setRows] = useState<ItemSHSFRow[]>([]);
  useEffect(() => {
    const getData = async () => {
      setIsLoading(true);
      const data = await ItemAPI.getItemHistorySHSF(props);
      setRows(data.data);
      setIsLoading(false);
    };
    getData();
  }, []);
  const cols = [
    {
      id: 'date_created',
      label: 'Date',
      dataType: dataTypes.date,
    },
    {
      id: 'order_no',
      label: 'Order #',
    },
    {
      id: 'carrier_name',
      label: 'Carrier',
    },
    {
      id: 'route_description',
      label: 'Route',
    },
    {
      id: 'ship_quantity',
      label: 'Shipped Quantity',
      dataType: dataTypes.number,
    },
    {
      id: 'shipped_from',
      label: 'Warehouse',
    },
    {
      id: 'shipped_to',
      label: 'Sold to',
    },
  ];
  return isLoading ? (
    <Stack sx={{ width: '100%', paddingY: 2 }} alignItems={'center'}>
      <CircularProgress />
    </Stack>
  ) : (
    <TableWrapper rows={rows} columns={cols} transformRows />
  );
}
